import type React from 'react';
import { FormField, Input, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { ZONING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Zoning({ section, setSectionValues }: Props) {
  function onZoningDistrictChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [ZONING.FIELD_NAME.ZONING_DISTRICT]: value,
    });
  }

  return (
    <FormField
      required
      label={<Label>What is the Zoning District for your property?</Label>}
      control={
        <Input value={section.getFieldValue(ZONING.FIELD_NAME.ZONING_DISTRICT)} onChange={onZoningDistrictChange} />
      }
    />
  );
}

export default Zoning;
